/* eslint-disable @typescript-eslint/no-explicit-any */
import * as L from 'leaflet';

export default async function initInteractiveMap(): Promise<void> {
    const $interactiveMapContainer = document.querySelectorAll<HTMLElement>('.block-texte-carte-interactive');
    $interactiveMapContainer.forEach(async ($container) => {
        new InteractiveMap($container);
    });
}

class InteractiveMap {
    $el: HTMLElement | null | undefined;
    mobileBreakpoint: number;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.mobileBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-main-header')) + 1;
        this.initMap('departements');
        this.initMap('regions');
        this.sortMobileFedeList();
        this.switchMapHandler();
    }

    async initMap(container: string): Promise<void> {
        const mapContainer = this.$el?.querySelector(`#interactive-map-${container}`) as HTMLElement;
        const toolTip = this.$el?.querySelector(`.tool-tip-${container}`) as HTMLElement;
        let datasMap;

        if (container === 'departements') {
            datasMap = JSON.parse((window as any).datas_map_departements);
        } else if (container === 'regions') {
            datasMap = JSON.parse((window as any).datas_map_regions);
        }

        const fond_carte = await fetchData(datasMap.fond_carte);
        const federations = await fetchData(datasMap.federations);

        const texts = datasMap.texts;

        // ajustement du zoom
        const map = L.map(mapContainer, {
            zoomSnap: 0.10,
            scrollWheelZoom: false
        });

        map.setView([46.227638, 2.213749], 5.40);
        // on enleve le drag
        map.dragging.disable();

        const getColor = (type: string) => {
            return type == 'departement' ? '#EC008C' : type == 'federation' ? '#532D7C' : '#E4DDD1';
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const style = (feature: any) => {
            const color = federations[feature.properties.code]?.locale || false;
            return {
                fillColor: getColor(color),
                weight: .5,
                opacity: 1,
                color: '#FFF',
                fillOpacity: 1,
            };
        }

        let geojson = L.geoJson(fond_carte);

        const highlightFeature = (e: any) => {
            const layer = e.target;
            const name = federations[layer.feature.properties.code]?.nom || '';
            const adherents = federations[layer.feature.properties.code]?.adherents || '';

            if (container === 'departements') {
                const locale = federations[layer.feature.properties.code]?.locale ? texts[federations[layer.feature.properties.code]?.locale] : '';
                const zip = layer.feature.properties.code || '';

                if (name != '') {
                    toolTip.style.display = 'block';

                    toolTip.innerHTML = [
                        `<div class="title">${name} (${zip})</div>`,
                        adherents ? `<div class="adherents">${adherents} adhérents</div>` : '',
                        `<div class="locale">${locale}</div>`,
                    ].join('');
                }

            } else if (container === 'regions') {
                const locale = texts['region'];
                if (name != '') {
                    toolTip.style.display = 'block';
    
                    toolTip.innerHTML = [
                        `<div class="title">${name}</div>`,
                        adherents ? `<div class="adherents">${adherents} adhérents</div>` : '',
                        `<div class="locale">${locale}</div>`,
                    ].join('');
                }
            }

            layer.setStyle({
                weight: 1,
                fillColor: '#860050',
            });

            if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
                layer.bringToFront();
            }
        }

        const resetHighlight = (e: any) => {
            geojson.resetStyle(e.target);
            toolTip.style.display = 'none';
        }

        const gotoUrl = (e: any) => {
            const layer = e.target;
            const url = federations[layer.feature.properties.code]?.url || '';
            if (url) {
                location.href = url;
            }
        }

        function onEachFeature(_feature: any, layer: any) {
            layer.on({
                mouseover: highlightFeature,
                mouseout: resetHighlight,
                click: gotoUrl,
            });
        }

        geojson = L.geoJson(fond_carte, {
            style: style,
            onEachFeature: onEachFeature
        }).addTo(map);

        this.$el?.addEventListener('mousemove', (e) => {
            const boundaries = this.$el?.getBoundingClientRect();
            const boundariesLeft = boundaries?.left;
            const boundariesTop = boundaries?.top;
            if (boundariesLeft && boundariesTop) {
                const offset = 5;
                const x = (e.clientX - boundariesLeft) + offset;
                const y = (e.clientY - boundariesTop) + offset;

                toolTip.style.top = y.toString() + 'px';
                toolTip.style.left = x.toString() + 'px';
            }
        })
    }

    sortMobileFedeList() {
        function comparator(a: any, b: any) {
            if (a.dataset.zip < b.dataset.zip)
                return -1;
            if (a.dataset.zip > b.dataset.zip)
                return 1;
            return 0;
        }

        const choices = this.$el?.querySelectorAll('[data-zip]');
        const content = this.$el?.querySelector('.dropdown-content') as any;

        if (choices && content) {
            const subjectsArray = Array.from(choices);
            const sorted = subjectsArray.sort(comparator);

            sorted.forEach(el => content.appendChild(el))
        }

    }

    switchMapHandler() {
        const switcher = this.$el?.querySelector('.js-map-switcher');

        const buttons = switcher?.querySelectorAll('.map-button');
        const contents = switcher?.querySelectorAll('.map-content');

        buttons?.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.classList.contains('map-button--active')) {
                    return;
                } else {
                    buttons.forEach(btn => btn.classList.remove('map-button--active'));
                    button.classList.add('map-button--active');
                    contents?.forEach((ctn) => {
                        ctn.classList.remove('map-content--active');
                        if (ctn.getAttribute('data-map-switch') === button.getAttribute('data-map-switch')) {
                            ctn.classList.add('map-content--active');
                        }
                    });
                }
            })
        })
    }
}

async function fetchData(fileURL: string): Promise<any> {
    const response = await fetch(fileURL);
    const json = await response.json();

    return json;
}